import React, { forwardRef } from 'react';
import { Grid } from '@mui/material';
import { useCustomStyles } from '../../hooks';
import Table from '../AgGrid';
import { AgGridReactProps } from 'ag-grid-react';

interface TableGridItemProps extends AgGridReactProps {
    height?: string;
    defaultColDef?: any;
}

const TableGridItem = forwardRef<any, TableGridItemProps>(({ children, height, ...props }, ref) => {
    const classes = useCustomStyles();
    return (
        <Grid
            item
            xs={12}
            sx={classes.tableGridItem}
            classes={height === 'auto' ? { root: 'MuiGrid--auto-height' } : {}}
        >
            <Table ref={ref} height={height} {...props}>
                {children}
            </Table>
        </Grid>
    );
});

export default TableGridItem;
